import { useTranslation } from '../../i18n/I18nContext';

type SettingHelpKey =
  | 'discovery_host_ip'
  | 'api_username'
  | 'api_password'
  | 'refresh_interval'
  | 'analytics_db_url'
  | 'finance_db_host'
  | 'finance_db_port'
  | 'finance_db_user'
  | 'finance_db_password'
  | 'finance_db_name'
  | 'app_root_dir'
  | 'freqtrade_root_dir'
  | 'freqtrade_data_dir'
  | 'freqtrade_agent_root_dir'
  | 'fred_api_key'
  | 'newsapi_key';

interface SettingHelpProps {
  settingKey: SettingHelpKey;
}

function HelpLink({ href, children }: { href: string; children: string }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="underline decoration-dotted underline-offset-2 hover:text-blue-600 dark:hover:text-blue-300"
    >
      {children}
    </a>
  );
}

export function SettingHelp({ settingKey }: SettingHelpProps) {
  const { t } = useTranslation();
  const sharedClassName = 'mt-1 text-xs leading-5 text-gray-500 dark:text-gray-400';

  switch (settingKey) {
    case 'discovery_host_ip':
      return <p className={sharedClassName}>{t('help.discovery_host_ip')}</p>;
    case 'api_username':
      return <p className={sharedClassName}>{t('help.api_username')}</p>;
    case 'api_password':
      return <p className={sharedClassName}>{t('help.api_password')}</p>;
    case 'refresh_interval':
      return <p className={sharedClassName}>{t('help.refresh_interval')}</p>;
    case 'analytics_db_url':
      return <p className={sharedClassName}>{t('help.analytics_db_url')}</p>;
    case 'finance_db_host':
      return <p className={sharedClassName}>{t('help.finance_db_host')}</p>;
    case 'finance_db_port':
      return <p className={sharedClassName}>{t('help.finance_db_port')}</p>;
    case 'finance_db_user':
      return <p className={sharedClassName}>{t('help.finance_db_user')}</p>;
    case 'finance_db_password':
      return <p className={sharedClassName}>{t('help.finance_db_password')}</p>;
    case 'finance_db_name':
      return <p className={sharedClassName}>{t('help.finance_db_name')}</p>;
    case 'app_root_dir':
      return <p className={sharedClassName}>{t('help.app_root_dir')}</p>;
    case 'freqtrade_root_dir':
      return <p className={sharedClassName}>{t('help.freqtrade_root_dir')}</p>;
    case 'freqtrade_data_dir':
      return <p className={sharedClassName}>{t('help.freqtrade_data_dir')}</p>;
    case 'freqtrade_agent_root_dir':
      return <p className={sharedClassName}>{t('help.freqtrade_agent_root_dir')}</p>;
    case 'fred_api_key':
      return (
        <p className={sharedClassName}>
          {t('help.fred_api_key')}
          {' '}
          <HelpLink href="https://fred.stlouisfed.org/docs/api/fred/v2/api_key.html">{t('help.fred_link_label')}</HelpLink>.
        </p>
      );
    case 'newsapi_key':
      return (
        <p className={sharedClassName}>
          {t('help.newsapi_key')}
          {' '}
          <HelpLink href="https://newsapi.org/docs/get-started">{t('help.news_link_label')}</HelpLink>.
        </p>
      );
    default:
      return null;
  }
}
